// libs
import React from 'react';

import { TypographyType } from '@lyearn/ui';
import * as ContentDetails from '@/components/ContentDetails';
// hooks
import { useHeroContext } from '@/modules/corporate/components/DetailPageComponents/DetailHero/context';

const Label = (props: Partial<TypographyType>) => {
  const {
    content: { label },
  } = useHeroContext();

  const content = {
    label,
  };

  if (!label) {
    return null;
  }

  return (
    <ContentDetails.Provider content={content}>
      <ContentDetails.Label {...props} />
    </ContentDetails.Provider>
  );
};

export default Label;
